/* Outer sleeves upsell popup. Ported from the previous theme; see snippets/jc-upsell.liquid. */
  (function () {
    var STORAGE_KEY = 'jc_os_upsell_dismissed_v4';
    var WHITELIST = new Set([12299825938772, 12461399572820, 15772283666772]);
    var el = document.getElementById('jc-os-upsell');
    if (!el) return;
    if (window.jcUpsellReady) return;
    window.jcUpsellReady = true;
    var dismissedInMemory = false;
    var lastFocus = null;
    var path = window.location.pathname || '';
    if (path.indexOf('/cart') === 0 || path.indexOf('/checkout') === 0 || path.indexOf('/collections/outer-sleeves') !== -1) return;
    function isDismissed() { if (dismissedInMemory) return true; try { return !!sessionStorage.getItem(STORAGE_KEY); } catch (e) { return false; } }
    function markDismissed() { dismissedInMemory = true; try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {} }
    function setBackgroundInert(on) {
      Array.prototype.forEach.call(document.body.children, function (node) {
        if (node === el || node.tagName === 'SCRIPT' || node.tagName === 'STYLE') return;
        if (on) { if (!node.inert) { node.inert = true; node.setAttribute('data-jc-inert', ''); } }
        else if (node.hasAttribute('data-jc-inert')) { node.inert = false; node.removeAttribute('data-jc-inert'); }
      });
    }
    function show() {
      if (isDismissed()) return;
      if (!el.hidden && el.classList.contains('is-visible')) return;
      markDismissed(); /* one-shot: never re-prompt this session */
      try { document.dispatchEvent(new CustomEvent('jc:upsell-show')); } catch (e) {}
      lastFocus = document.activeElement;
      el.hidden = false;
      document.body.style.overflow = 'hidden';
      setBackgroundInert(true);
      requestAnimationFrame(function () {
        el.classList.add('is-visible');
        var closeBtn = el.querySelector('.jc-os-upsell__close');
        if (closeBtn) closeBtn.focus({ preventScroll: true });
      });
      document.addEventListener('keydown', onKey, true);
    }
    function hide(dismiss) {
      el.classList.remove('is-visible');
      document.removeEventListener('keydown', onKey, true);
      setBackgroundInert(false);
      var drawerOpen = document.querySelector('cart-drawer.active');
      if (!drawerOpen) document.body.style.overflow = '';
      setTimeout(function () { el.hidden = true; }, 220);
      if (lastFocus && document.contains(lastFocus) && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      lastFocus = null;
      if (dismiss) markDismissed();
    }
    function onKey(e) { if (e.key === 'Escape') { e.stopPropagation(); e.preventDefault(); hide(true); } }
    el.querySelector('.jc-os-upsell__close').addEventListener('click', function () { hide(true); });
    var declineBtn = el.querySelector('.jc-os-upsell__decline');
    if (declineBtn) declineBtn.addEventListener('click', function () { hide(true); });
    el.addEventListener('click', function (e) { if (e.target === el) hide(true); });
    el.querySelectorAll('.jc-os-upsell__add').forEach(function (btn) { btn.addEventListener('click', function () { addToCart(btn); }); });
    function addToCart(btn) {
      var variantId = btn.getAttribute('data-jc-add-variant');
      if (!variantId || btn.disabled) return;
      var addedLabel = btn.getAttribute('data-jc-added-label') || '✓';
      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = '…';
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }], sections: ['cart-icon-bubble', 'cart-drawer'] })
      })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (data) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
          var wasOpen = drawer.classList.contains('active');
          drawer.classList.remove('is-empty');
          if (wasOpen) {
            /* refresh in place; do not re-run the open animation or move focus under the popup */
            drawer.getSectionsToRender().forEach(function (section) {
              var target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
              if (!target || !data.sections[section.id]) return;
              target.innerHTML = drawer.getSectionInnerHTML(data.sections[section.id], section.selector);
            });
            var overlay = drawer.querySelector('#CartDrawer-Overlay');
            if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
          } else if (!window.matchMedia('(max-width: 749px)').matches) {
            drawer.renderContents(data);
          } else {
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble && data.sections['cart-icon-bubble']) bubble.innerHTML = drawer.getSectionInnerHTML(data.sections['cart-icon-bubble'], '.shopify-section');
          }
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate) {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'jc-os-upsell', productVariantId: variantId }); } catch (e) {}
        }
        btn.textContent = addedLabel;
        btn.classList.add('is-added');
        setTimeout(function () { hide(true); }, 900);
      })
      .catch(function () { btn.disabled = false; btn.textContent = originalText; });
    }
    /* Is the added product in the OCG sleeves collection? One small request per product,
       made only after an add (sections/jc-ocg-check.liquid), cached for the session. */
    function isOcgProduct(handle) {
      var key = 'jc_ocg_check_' + handle;
      try {
        var cached = sessionStorage.getItem(key);
        if (cached !== null) return Promise.resolve(cached === '1');
      } catch (e) {}
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=jc-ocg-check', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var yes = html.indexOf('ocg:1') !== -1;
          try { sessionStorage.setItem(key, yes ? '1' : '0'); } catch (e) {}
          return yes;
        })
        .catch(function () { return false; });
    }
    /*
     * Trigger ONLY at the moment an OCG-sleeves product is ADDED to the cart
     * (never on page load / reload) and at most once per session; skip if outer sleeves are
     * already in the cart.
     */
    function onItemsAdded(items) {
      if (isDismissed()) return;
      if (items.some(function (it) { return WHITELIST.has(it.product_id); })) { markDismissed(); return; }
      var cartRequest = (window.jcGetCart ? window.jcGetCart() : fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }))
        .catch(function () { return null; });
      var checks = Promise.all(items.map(function (it) { return it.handle ? isOcgProduct(it.handle) : Promise.resolve(false); }));
      Promise.all([checks, cartRequest]).then(function (results) {
        if (!results[0].some(Boolean)) return;
        var cart = results[1];
        if (cart && Array.isArray(cart.items) && cart.items.some(function (it) { return WHITELIST.has(it.product_id); })) { markDismissed(); return; }
        setTimeout(show, 150);
      });
    }
    /* Dawn publishes cartUpdate after every add. An add response (unlike a full cart) has no
       item_count: a single line item or { items: [...] }. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        var data = event && event.cartData;
        if (!data || data.status || 'item_count' in data || event.source === 'jc-os-upsell') return;
        var items = Array.isArray(data.items) ? data.items : [data];
        items = items.filter(function (it) { return it && typeof it.product_id === 'number'; });
        if (items.length) onItemsAdded(items);
      });
    }
  })();
